var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 149 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.554 152.775L139.718 130.671C137.654 125.526 136.604 120.11 136.604 114.592V74.5784C136.604 46.854 118.156 23.597 92.9692 15.7454C91.4799 7.01215 83.8972 0.30957 74.7235 0.30957C65.5499 0.30957 57.9671 7.01215 56.4779 15.7454C31.2929 23.5987 12.8084 46.8551 12.8084 74.5784V114.557C12.8084 120.109 11.7584 125.525 9.69373 130.636L0.858508 152.741C0.0805206 154.637 0.317183 156.803 1.46783 158.495C2.61848 160.187 4.54848 161.203 6.57921 161.203H53.6331C58.0345 168.651 65.8537 173.592 74.6548 173.592C83.4559 173.592 91.3093 168.683 95.6766 161.203H142.73C144.795 161.203 146.691 160.187 147.842 158.495C149.094 156.836 149.331 154.671 148.553 152.774L148.554 152.775Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon_bell.8c8065e9951a22691450afd391879da1.svg";
export { ForwardRef as ReactComponent };